export default __webpack_public_path__ + "static/media/img_celebrating_character_group.7129bc35.png";